module.exports = __webpack_public_path__ + "static/assets/772a3ad67ba100c57c4436f522e9e7af.png";